export enum TransferMethod {
  AllAvailableCash = 'AllAvailableCash',
  ExactAmount = 'ExactAmount',
}
